import styled from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const SuggestionTooltip = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: ${getToken('spacing-2')};
  width: 270px;
  background-color: #000;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: ${getToken('elevation-2')};
  border-radius: ${getToken('border-radius-s')};
  padding: ${getToken('spacing-2')} ${getToken('spacing-3')};
  color: rgb(${getToken('color-text-inverted')});
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  line-height: 1.3;
`;

export const SuggestionArrow = styled.div`
  position: absolute;
  top: -5px;
  right: 24px;
  width: 10px;
  height: 10px;
  background-color: #000;
  border-left: 1px solid rgba(255, 255, 255, 0.12);
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  transform: rotate(45deg);
`;

export const SuggestionText = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const SuggestionLink = styled.a`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: transform 0.15s ease;

  &:hover {
    transform: scale(1.08);
  }
`;

export const SuggestionClose = styled.button`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  padding: 0;
  background: rgba(255, 255, 255, 0.15);
  color: rgb(${getToken('color-text-inverted')});
`;
